/* eslint-disable prefer-destructuring */
import { eventBasedSynchronizer } from '$logic/lib/sync/event-based'

type UserPreferencesSync = {
  roomIds: string[]
  action: 'ADD' | 'DELETE'
  date: Date
}

const synchronizer = eventBasedSynchronizer<UserPreferencesSync, false>(
  'userPreferencesSync',
  { merge: false },
)

export function set(patch: UserPreferencesSync) {
  return synchronizer.set('me', patch)
}

export async function get() {
  const { items, ...rest } = await synchronizer.getAll()
  return { items: items[0]?.patches, ...rest }
}
